import React, { useEffect, Suspense, lazy } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Link,
  Route,
  withRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import { batch } from "react-redux";
import { Switch, BrowserRouter as Router } from "react-router-dom";
import { authProtectedRoutes, betSlipRoutes, publicRoutes } from "./routes";
import { useIdleTimer } from "react-idle-timer";
import { ThreeDots } from "react-loader-spinner";

// Import all middleware
import Authmiddleware from "./routes/route";
import { getAllLeagues } from "./store/Leagues/actions";
import { getAllLocations } from "./store/Locations/actions";
import AppLayout from "./components/Layouts/AppLayout";
// Import scss
import "./App.css";
import { logoutUser } from "./store/Auth/actions";
import BetSlip from "./pages/BetSlip/BetSlip";
import { getAllSports } from "./store/Sports/actions";
import { getAllBanners } from "./store/Banners/actions";
import { getUrlLastPart } from "./components/Common/Utils/helpers";
import { setActiveFooterTab, setActiveTab } from "./store/actions";
import CommingSoon from "./components/Layouts/CommingSoon";
import GamesLoader from "./components/Common/GamesLoader";
import { getAllProducts } from "./store/Products/actions";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./components/ui/dialog";
import { captureReferralCodeFromURL } from "./helpers/referralUtils";
import { getTokenFromLocalStorage } from "./helpers/utils";

const isLoggedIn = getTokenFromLocalStorage() ? true : false;

/**
 * Component to handle referral code capture from URLs
 * Captures codes from {BASE_URL}/{referral_code} format
 */
function ReferralCodeHandler() {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const pathname = location.pathname;

    // Try to capture referral code from URL
    const capturedReferralCode = captureReferralCodeFromURL(pathname);

    // If a referral code was captured, redirect to sports/home page
    if (capturedReferralCode) {
      console.info("Referral code captured, redirecting to home...");
      // Redirect to sports page (home)
      history.replace("/sports");
    }
  }, [location.pathname, history]);

  return null; // This component doesn't render anything
}

function App(props) {
  const dispatch = useDispatch();
  useEffect(() => {
    injectGA();
    if (getUrlLastPart() == "sports") {
      dispatch(setActiveTab("home-upcoming"));
      dispatch(setActiveFooterTab("home"));
    } else {
      dispatch(setActiveTab(getUrlLastPart()));
    }
    getAllLookupsData();
  }, []);
  const injectGA = () => {
    if (typeof window == "undefined") {
      return;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    if (isLoggedIn) {
      let userId = JSON.parse(localStorage.getItem("user"))?.user?.id;
      gtag("set", { user_id: userId });
    }
    gtag("js", new Date());

    gtag("config", "G-3EVKPDC7YL");
  };
  // const timeout = 3000;
  // 1000 ms * 60 sec * 5 min = 300,000 ms
  // 300,000 ms / 1000 / 60 = 5 minutes
  const timeout = 1000 * 60 * 5; // 5 minutes
  const handleOnIdle = () => {
    setShowIdleModal(false);
    clearInterval(idleTimeoutRef.current);
    const { history } = props;
    if (![undefined, null, ""].includes(getTokenFromLocalStorage())) {
      dispatch(logoutUser(history));
    }
  };

  const [showIdleModal, setShowIdleModal] = React.useState(false);
  const [idleCountdown, setIdleCountdown] = React.useState(300); // 5 minutes in seconds
  const idleTimeoutRef = React.useRef(null);

  // useIdleTimer({
  //   timeout,
  //   onIdle: () => {
  //     // Only show modal if user is logged in
  //     if (sessionStorage.getItem("token")) {
  //       setShowIdleModal(true);
  //       setIdleCountdown(300);
  //       // Start countdown
  //       idleTimeoutRef.current = setInterval(() => {
  //         setIdleCountdown((prev) => {
  //           if (prev <= 1) {
  //             clearInterval(idleTimeoutRef.current);
  //             handleOnIdle();
  //             setShowIdleModal(false);
  //             return 0;
  //           }
  //           return prev - 1;
  //         });
  //       }, 1000);
  //     }
  //   },
  //   // onActive: () => {
  //   //   // Hide modal and clear countdown if user becomes active
  //   //   if (showIdleModal) {
  //   //     setShowIdleModal(false);
  //   //     clearInterval(idleTimeoutRef.current);
  //   //   }
  //   // },
  //   debounce: 500,
  //   enabled: !!sessionStorage.getItem("token"), // Only enable idle timer if logged in
  // });

  // Cleanup interval on unmount
  
  
  useEffect(() => {
    return () => clearInterval(idleTimeoutRef.current);
  }, []);

  const getAllLookupsData = () => {
    batch(() => {
      dispatch(getAllLeagues());
      dispatch(getAllLocations());
      dispatch(getAllSports());
      dispatch(getAllBanners());
      dispatch(getAllProducts());
    });
  };

  // Lazy load components

  const LazyBetSlip = lazy(() => import("./pages/BetSlip/BetSlip"));
  const LazyCommingSoon = lazy(
    () => import("./components/Layouts/CommingSoon"),
  );

  // Simple loading screen component
  const LoadingScreen = () => (
    <div className="h-screen w-screen flex justify-center items-center">
      <GamesLoader text="Loading..." />
    </div>
  );

  return (
    <>
      {/* <Dialog open={showIdleModal} onOpenChange={setShowIdleModal}>
        <DialogContent className="!bg-white text-black">
          <DialogHeader className="flex flex-col items-start">
            <DialogTitle>You've been inactive</DialogTitle>
            <DialogDescription>
              You will be logged out in{" "}
              <span className="font-bold">{idleCountdown}</span> seconds due to
              inactivity.
            </DialogDescription>
          </DialogHeader>
          <div className="flex gap-2 mb-2 justify-end">
            <button
              className="text-sm py-1 px-3 rounded flex items-center justify-center bg-[#2E2E2E] text-[var(--bet-betyakata-header)]"
              onClick={() => {
                setShowIdleModal(false);
                clearInterval(idleTimeoutRef.current);
              }}
            >
              Stay Logged In
            </button>
            <button
              className="bg-[var(--bet-betyakata-header)] text-black text-sm py-1 px-3 rounded flex items-center justify-center"
              onClick={handleOnIdle}
            >
              Log Out
            </button>
          </div>
        </DialogContent>
      </Dialog> */}
      <Router>
        <ReferralCodeHandler />
        <Suspense fallback={<LoadingScreen />}>
          <Switch>
            <Route path="/betSlip">
              <LazyBetSlip />
            </Route>
            <Route path="/comming-soon">
              <LazyCommingSoon />
            </Route>
            {publicRoutes.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                layout={AppLayout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
                exact
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                layout={AppLayout}
                component={route.component}
                key={idx}
                isAuthProtected={true}
                exact
              />
            ))}
          </Switch>
        </Suspense>
      </Router>
    </>
  );
}

export default withRouter(App);
